type AppConfig = {
  WebView: boolean;
  EmbedWindcave: boolean;
};

export const appConfig: AppConfig = {
  WebView: import.meta.env.VITE_WEB_VIEW?.toLowerCase() === "true",
  EmbedWindcave: import.meta.env.VITE_EMBED_WINDCAVE?.toLowerCase() === "true",
};
